<section class="container">
  @if (tenantService.selectedTenant) {
    <div>
      <div class="header-wrapper">
        <h1>Lists</h1>
      </div>
      <div class="content-wrapper">
        <div class="lists-list">
          <mat-list dense data-qa-id="lists-list">
            @for (list of lists; track list) {
              <mat-list-item
                tabindex="0"
                (click)="setEditingList(list)"
                (keydown.enter)="setEditingList(list)"
                (keydown.space)="setEditingList(list); $event.preventDefault()"
                [ngClass]="{'selected': editingList === list}">
                {{list.FriendlyName}}
                <mat-icon tabindex="0" role="button" (click)="deleteList(list)" (keydown.enter)="deleteList(list)" (keydown.space)="deleteList(list); $event.preventDefault()" class="delete-item">delete</mat-icon>
              </mat-list-item>
            }
          </mat-list>
        </div>
        <div class="list-editor">
          @if (editingList) {
            <list-editor [listAlias]="editingList.Key" embedded="true" class="list-editor-list"></list-editor>
          }
        </div>
      </div>
    </div>
  }
</section>
